import gtm from "../utils/GTM";

const Search = (function () {
  const $searchPage = $(".search-page");
  const $searchReset = $(".js-search-page-reset");
  const $searchInput = $("#search-page-search");

  function init() {
    $(function () {
      $searchReset.on("click", function () {
        $searchInput.removeAttr("value").focus();
      });

      const queryTerm = $searchPage.data("search-query");
      if (queryTerm && queryTerm.trim()) {
        gtm.datalayerPush("site_search", {
          search_term: queryTerm,
          search_result_found: $searchPage.data("search-amount")
            ? "true"
            : "false",
          search_result_amount: $searchPage.data("search-amount"),
        });
      }
    });
  }

  return {
    init,
  };
})();

export default Search;
